import { hydrateRoot } from 'react-dom/client'
import { applyEnvironmentWatermark } from '@/common/lib/environmentWatermark'
import '@/common/styles/environmentWatermark.css'
import './app/styles/index.css'
import { Landing } from './pages/Landing'

applyEnvironmentWatermark()

// Дерево должно совпадать с SSR в scripts/render.tsx (renderToString(<Landing />)),
// иначе useId в баннерах даёт другие id и падает hydration.
const rootElement = document.getElementById('root')
if (rootElement) {
    hydrateRoot(rootElement, <Landing />)
}
